import React, { useContext } from "react";

import { observer } from "mobx-react";
import { usePathname, useRouter } from "../../hooks/useNavigation";

import ComponentContext from "../../../contexts/ComponentContext";
import { useStores } from "../../../contexts/StoreContext";
import CardsListWithVacancyView from "./CardListWithVacancyView/CardsListWithVacancyView";
import DefaultSearchResults from "./DefaultSearchResults";
import GridSearchResults from "./GridSearchResults";
import GridWithFilterSearchResults from "./GridWithFilterSearchResults";
import GridWithHeaderFilterSearchResults from "./GridWithHeaderFilterSearchResults";
import ShrinkingThumbnail from "./ThumbnailSearchResults/ShrinkingThumbnail";
import ThumbnailSearchResults from "./ThumbnailSearchResults/ThumbnailSearchResults";

const resultsTypeMap = {
  cardView: GridSearchResults,
  default: DefaultSearchResults,
  gridWithFilter: GridWithFilterSearchResults,
  gridWithHeaderFilter: GridWithHeaderFilterSearchResults,
  basicWithFilters: CardsListWithVacancyView,
  withThumbnail: ThumbnailSearchResults,
  shrinkingThumbnail: ShrinkingThumbnail,
};

function SearchResults() {
  const { type, thumbnail, resultsPageHref } = useContext(ComponentContext);

  const { filtersStore } = useStores();

  const { resetAllFilters } = filtersStore;

  const router = useRouter();
  const pathname = usePathname();

  const href = resultsPageHref || pathname.split("?")[0];

  const handleReset = () => {
    router
      .push({
        pathname: href,
      })
      .then(resetAllFilters);
  };

  const SearchResultComponent = resultsTypeMap[type] || DefaultSearchResults;

  const thumbnailUrl =
    thumbnail?.formats?.thumbnail?.url || thumbnail?.url || null;

  const props = {
    handleReset,
    thumbnailUrl,
  };

  return <SearchResultComponent {...props} />;
}

export default observer(SearchResults);
